import React from "react";

const GradientButton = (props) => {
  return (
    <div className="gradient-button-wrapper">
      <div
        className={
          props.className
            ? "gradient-button " + props.className
            : "gradient-button"
        }
        onClick={() => { props.onClick(); }}
      >
        <div className="gradient-button-glow" />
        {props.text}
        <div className="gradient-button-glow custombottom" />
      </div>
    </div>
  );
};

export default GradientButton;
